import { useOnboardingStore } from '../../../store/onboardingStore';
import { dictionary } from '../../../utils/dictionary';
import { useAuth } from '../../../context/AuthContext';
import { ConfirmScrapedProductView } from '../ui/ConfirmScrapedProductView';

interface StepConfirmScrapedProductProps {
  onBack: () => void;
  onConfirm: () => void;
}

export function StepConfirmScrapedProduct({ onBack, onConfirm }: StepConfirmScrapedProductProps) {
  const { language } = useAuth();
  const { data, updateProductData, updateVisualContent } = useOnboardingStore();
  const { productData, visualContent } = data;
  const images = visualContent.images || [];

  return (
    <ConfirmScrapedProductView
      title={dictionary['confirm-your-main-product']?.[language] ?? 'Confirma tu Producto Principal'}
      subtitle={dictionary['edit-data-if-needed']?.[language] ?? 'Edita los datos si es necesario antes de continuar.'}
      name={productData.name || ''}
      description={productData.details || ''}
      images={images}
      onNameChange={(value) => updateProductData({ ...productData, name: value })}
      onDescriptionChange={(value) => updateProductData({ ...productData, details: value })}
      onImagesUpdate={(newImages) => updateVisualContent({ images: newImages })}
      onBack={onBack}
      onConfirm={onConfirm}
    />
  );
}
